export const ADD_SONG = 'ADD_SONG'
export const GET_SONGS = 'GET_SONGS'
export const SEARCH_SONGS = 'SEARCH_SONGS'
export const GET_SONG = 'GET_SONG'
export const EDIT_SONG = 'EDIT_SONG'
export const DELETE_SONG = 'DELETE_SONG'